<script setup>
import { useRoute, useRouter } from 'vue-router'
const router = useRouter()

const goBack = () => {
    router.back()
}

</script>

<template>
    <div class="headline">
      <button class="headline__left" @click.prevent="goBack">
        <Icon name="left" />
      </button>
      <div class="headline__title">
        <slot></slot>
      </div>
    </div>
</template>